import styled from '@emotion/styled'

type FieldSetProps = {
  direction: 'vertical' | 'horizontal'
}

export const FieldSet = styled.div<FieldSetProps>`
  display: flex;
  margin: 0 0 8px 0;
  flex-direction: ${props => (props.direction === 'horizontal' ? 'row' : 'column')};

  & > * {
    margin-right: ${props => (props.direction === 'horizontal' ? '24px' : '0')};
    margin-bottom: ${props => (props.direction === 'horizontal' ? '0' : '8px')};
  }
`
